export const COLUMN_HEADERS = ["Element Name", "No. of Cos", "No. of Ees", "10th", "25th", "50th", "Avg", "75th", "90th"];

export const ELEMENT_NAMES = ["Base Salary", "Actual Bonus Amount", "Actual Bonus %", "Total Cash", "Target Bonus Amt", "Target Bonus %", "Total Target Cash", "Actual LTI Amt", "Actual LTI %", "Target LTI %", "Total Direct", "Total Target Direct", "Actual Sales Incentive $", "Actual Sales Incentive %", "Target Sales Incentive $", "Target Sales Incentive %", "Cash Allowance $", "Guaranteed Incentive $", "Total Guaranteed Pay $", "Fringe Benefits $", "Total Remuneration $", "Total Cost of Employment $"
];

export const INITIAL_SURVEY_JOB_STATE = {
  client_job_code: '',
  client_job_code_key: '',
  job_code: '',
  job_description: '',
  job_scope: '',
  pub_survey_jobs_columns: {
    currency: '',
    job_title: ''
  },
  survey_code: '',
  udf_columns: {}
};

export const INITIAL_SURVEY_STATE = {
  apply_sub_to_subgroups: false,
  geography: '',
  industry: '',
  pub_survey_code: '',
  pub_survey_effective_date: null,
  pub_survey_long_name: '',
  pub_survey_publisher: '',
  pub_survey_short_name: '',
  survey_overview: ''
}

export const MARKET_ELEMENTS = {
  "actual_bonus_%": {
    "actual_bonus_%_10th": "actual_sti_pct_10th",
    "actual_bonus_%_25th": "actual_sti_pct_25th",
    "actual_bonus_%_50th": "actual_sti_pct_50th",
    "actual_bonus_%_75th": "actual_sti_pct_75th",
    "actual_bonus_%_90th": "actual_sti_pct_90th",
    "actual_bonus_%_avg": "actual_sti_pct_avg",
    "actual_bonus_%_no._of_cos": "actual_sti_pct_cos",
    "actual_bonus_%_no._of_ees": "actual_sti_pct_ees",
  },
  "actual_bonus_amount": {
    "actual_bonus_amount_10th": "incentive_paid_10th",
    "actual_bonus_amount_25th": "incentive_paid_25th",
    "actual_bonus_amount_50th": "incentive_paid_50th",
    "actual_bonus_amount_75th": "incentive_paid_75th",
    "actual_bonus_amount_90th": "incentive_paid_90th",
    "actual_bonus_amount_avg": "incentive_paid_avg",
    "actual_bonus_amount_no._of_cos": "incentive_paid_cos",
    "actual_bonus_amount_no._of_ees": "incentive_paid_ees"
  },
  "actual_lti_%": {
    "actual_lti_%_10th": "actual_lti_pct_10th",
    "actual_lti_%_25th": "actual_lti_pct_25th",
    "actual_lti_%_50th": "actual_lti_pct_50th",
    "actual_lti_%_75th": "actual_lti_pct_75th",
    "actual_lti_%_90th": "actual_lti_pct_90th",
    "actual_lti_%_avg": "actual_lti_pct_avg",
    "actual_lti_%_no._of_cos": "actual_lti_pct_cos",
    "actual_lti_%_no._of_ees": "actual_lti_pct_ees"
  },
  "actual_lti_amt": {
    "actual_lti_amt_10th": "lti_dollars_10th",
    "actual_lti_amt_25th": "lti_dollars_25th",
    "actual_lti_amt_50th": "lti_dollars_50th",
    "actual_lti_amt_75th": "lti_dollars_75th",
    "actual_lti_amt_90th": "lti_dollars_90th",
    "actual_lti_amt_avg": "lti_dollars_avg",
    "actual_lti_amt_no._of_cos": "lti_dollars_cos",
    "actual_lti_amt_no._of_ees": "lti_dollars_ees"
  },
  "actual_sales_incentive_%": {
    "actual_sales_incentive_%_10th": "actual_sales_inct_pct_10th",
    "actual_sales_incentive_%_25th": "actual_sales_inct_pct_25th",
    "actual_sales_incentive_%_50th": "actual_sales_inct_pct_50th",
    "actual_sales_incentive_%_75th": "actual_sales_inct_pct_75th",
    "actual_sales_incentive_%_90th": "actual_sales_inct_pct_90th",
    "actual_sales_incentive_%_avg": "actual_sales_inct_pct_avg",
    "actual_sales_incentive_%_no._of_cos": "actual_sales_inct_pct_cos",
    "actual_sales_incentive_%_no._of_ees": "actual_sales_inct_pct_ees"
  },
  "actual_sales_incentive_$": {
    "actual_sales_incentive_$_10th": "actual_sales_inct_10th",
    "actual_sales_incentive_$_25th": "actual_sales_inct_25th",
    "actual_sales_incentive_$_50th": "actual_sales_inct_50th",
    "actual_sales_incentive_$_75th": "actual_sales_inct_75th",
    "actual_sales_incentive_$_90th": "actual_sales_inct_90th",
    "actual_sales_incentive_$_avg": "actual_sales_inct_avg",
    "actual_sales_incentive_$_no._of_cos": "actual_sales_inct_cos",
    "actual_sales_incentive_$_no._of_ees": "actual_sales_inct_ees",
  },
  "base_salary": {
    "base_salary_10th": "base_salary_10th",
    "base_salary_25th": "base_salary_25th",
    "base_salary_50th": "base_salary_50th",
    "base_salary_75th": "base_salary_75th",
    "base_salary_90th": "base_salary_90th",
    "base_salary_avg": "base_salary_avg",
    "base_salary_no._of_cos": "total_companies",
    "base_salary_no._of_ees": "total_incumbents"
  },
  "cash_allowance_$": {
    "cash_allowance_$_10th": "cash_allowances_10th",
    "cash_allowance_$_25th": "cash_allowances_25th",
    "cash_allowance_$_50th": "cash_allowances_50th",
    "cash_allowance_$_75th": "cash_allowances_75th",
    "cash_allowance_$_90th": "cash_allowances_90th",
    "cash_allowance_$_avg": "cash_allowances_avg",
    "cash_allowance_$_no._of_cos": "cash_allowances_cos",
    "cash_allowance_$_no._of_ees": "cash_allowances_ees"
  },
  "fringe_benefits_$": {
    "fringe_benefits_$_10th": "fringe_benefits_10th",
    "fringe_benefits_$_25th": "fringe_benefits_25th",
    "fringe_benefits_$_50th": "fringe_benefits_50th",
    "fringe_benefits_$_75th": "fringe_benefits_75th",
    "fringe_benefits_$_90th": "fringe_benefits_90th",
    "fringe_benefits_$_avg": "fringe_benefits_avg",
    "fringe_benefits_$_no._of_cos": "fringe_benefits_cos",
    "fringe_benefits_$_no._of_ees": "fringe_benefits_ees",
  },
  "guaranteed_incentive_$": {
    "guaranteed_incentive_$_10th": "guaranteed_inct_10th",
    "guaranteed_incentive_$_25th": "guaranteed_inct_25th",
    "guaranteed_incentive_$_50th": "guaranteed_inct_50th",
    "guaranteed_incentive_$_75th": "guaranteed_inct_75th",
    "guaranteed_incentive_$_90th": "guaranteed_inct_90th",
    "guaranteed_incentive_$_avg": "guaranteed_inct_avg",
    "guaranteed_incentive_$_no._of_cos": "guaranteed_inct_cos",
    "guaranteed_incentive_$_no._of_ees": "guaranteed_inct_ees",
  },
  "target_bonus_%": {
    "target_bonus_%_10th": "target_sti_pct_10th",
    "target_bonus_%_25th": "target_sti_pct_25th",
    "target_bonus_%_50th": "target_sti_pct_50th",
    "target_bonus_%_75th": "target_sti_pct_75th",
    "target_bonus_%_90th": "target_sti_pct_90th",
    "target_bonus_%_avg": "target_sti_pct_avg",
    "target_bonus_%_no._of_cos": "target_sti_pct_cos",
    "target_bonus_%_no._of_ees": "target_sti_pct_ees",
  },
  "target_bonus_amt": {
    "target_bonus_amt_10th": "incentive_target_10th",
    "target_bonus_amt_25th": "incentive_target_25th",
    "target_bonus_amt_50th": "incentive_target_50th",
    "target_bonus_amt_75th": "incentive_target_75th",
    "target_bonus_amt_90th": "incentive_target_90th",
    "target_bonus_amt_avg": "incentive_target_avg",
    "target_bonus_amt_no._of_cos": "incentive_target_cos",
    "target_bonus_amt_no._of_ees": "incentive_target_ees"
  },
  "target_lti_%": {
    "target_lti_%_10th": "target_lti_pct_10th",
    "target_lti_%_25th": "target_lti_pct_25th",
    "target_lti_%_50th": "target_lti_pct_50th",
    "target_lti_%_75th": "target_lti_pct_75th",
    "target_lti_%_90th": "target_lti_pct_90th",
    "target_lti_%_avg": "target_lti_pct_avg",
    "target_lti_%_no._of_cos": "target_lti_pct_cos",
    "target_lti_%_no._of_ees": "target_lti_pct_ees"
  },
  "target_sales_incentive_%": {
    "target_sales_incentive_%_10th": "target_sales_inct_pct_10th",
    "target_sales_incentive_%_25th": "target_sales_inct_pct_25th",
    "target_sales_incentive_%_50th": "target_sales_inct_pct_50th",
    "target_sales_incentive_%_75th": "target_sales_inct_pct_75th",
    "target_sales_incentive_%_90th": "target_sales_inct_pct_90th",
    "target_sales_incentive_%_avg": "target_sales_inct_pct_avg",
    "target_sales_incentive_%_no._of_cos": "target_sales_inct_pct_cos",
    "target_sales_incentive_%_no._of_ees": "target_sales_inct_pct_ees"
  },
  "target_sales_incentive_$": {
    "target_sales_incentive_$_10th": "target_sales_inct_10th",
    "target_sales_incentive_$_25th": "target_sales_inct_25th",
    "target_sales_incentive_$_50th": "target_sales_inct_50th",
    "target_sales_incentive_$_75th": "target_sales_inct_75th",
    "target_sales_incentive_$_90th": "target_sales_inct_90th",
    "target_sales_incentive_$_avg": "target_sales_inct_avg",
    "target_sales_incentive_$_no._of_cos": "target_sales_inct_cos",
    "target_sales_incentive_$_no._of_ees": "target_sales_inct_ees",
  },
  "total_cash": {
    "total_cash_10th": "total_cash_paid_10th",
    "total_cash_25th": "total_cash_paid_25th",
    "total_cash_50th": "total_cash_paid_50th",
    "total_cash_75th": "total_cash_paid_75th",
    "total_cash_90th": "total_cash_paid_90th",
    "total_cash_avg": "total_cash_paid_avg",
    "total_cash_no._of_cos": "total_cash_cos",
    "total_cash_no._of_ees": "total_cash_ees"
  },
  "total_cost_of_employment_$": {
    "total_cost_of_employment_$_10th": "total_cost_of_employment_10th",
    "total_cost_of_employment_$_25th": "total_cost_of_employment_25th",
    "total_cost_of_employment_$_50th": "total_cost_of_employment_50th",
    "total_cost_of_employment_$_75th": "total_cost_of_employment_75th",
    "total_cost_of_employment_$_90th": "total_cost_of_employment_90th",
    "total_cost_of_employment_$_avg": "total_cost_of_employment_avg",
    "total_cost_of_employment_$_no._of_cos": "total_cost_of_employment_cos",
    "total_cost_of_employment_$_no._of_ees": "total_cost_of_employment_ees",
  },
  "total_direct": {
    "total_direct_10th": "total_direct_10th",
    "total_direct_25th": "total_direct_25th",
    "total_direct_50th": "total_direct_50th",
    "total_direct_75th": "total_direct_75th",
    "total_direct_90th": "total_direct_90th",
    "total_direct_avg": "total_direct_avg",
    "total_direct_no._of_cos": "total_direct_cos",
    "total_direct_no._of_ees": "total_direct_ees"
  },
  "total_guaranteed_pay_$": {
    "total_guaranteed_pay_$_10th": "total_guaranteed_pay_10th",
    "total_guaranteed_pay_$_25th": "total_guaranteed_pay_25th",
    "total_guaranteed_pay_$_50th": "total_guaranteed_pay_50th",
    "total_guaranteed_pay_$_75th": "total_guaranteed_pay_75th",
    "total_guaranteed_pay_$_90th": "total_guaranteed_pay_90th",
    "total_guaranteed_pay_$_avg": "total_guaranteed_pay_avg",
    "total_guaranteed_pay_$_no._of_cos": "total_guaranteed_pay_cos",
    "total_guaranteed_pay_$_no._of_ees": "total_guaranteed_pay_ees",
  },
  "total_remuneration_$": {
    "total_remuneration_$_10th": "total_remuneration_10th",
    "total_remuneration_$_25th": "total_remuneration_25th",
    "total_remuneration_$_50th": "total_remuneration_50th",
    "total_remuneration_$_75th": "total_remuneration_75th",
    "total_remuneration_$_90th": "total_remuneration_90th",
    "total_remuneration_$_avg": "total_remuneration_avg",
    "total_remuneration_$_no._of_cos": "total_remuneration_cos",
    "total_remuneration_$_no._of_ees": "total_remuneration_ees",
  },
  "total_target_cash": {
    "total_target_cash_10th": "total_target_cash_10th",
    "total_target_cash_25th": "total_target_cash_25th",
    "total_target_cash_50th": "total_target_cash_50th",
    "total_target_cash_75th": "total_target_cash_75th",
    "total_target_cash_90th": "total_target_cash_90th",
    "total_target_cash_avg": "total_target_cash_avg",
    "total_target_cash_no._of_cos": "total_target_cash_cos",
    "total_target_cash_no._of_ees": "total_target_cash_ees",
  },
  "total_target_direct": {
    "total_target_direct_10th": "total_target_direct_10th",
    "total_target_direct_25th": "total_target_direct_25th",
    "total_target_direct_50th": "total_target_direct_50th",
    "total_target_direct_75th": "total_target_direct_75th",
    "total_target_direct_90th": "total_target_direct_90th",
    "total_target_direct_avg": "total_target_direct_avg",
    "total_target_direct_no._of_cos": "total_target_direct_cos",
    "total_target_direct_no._of_ees": "total_target_direct_ees"
  }
}

export const NON_FORMATTED_COLUMNS = ['No. of Cos', 'No. of Ees'];
export const NUMERIC_COLUMN_TYPES = ["i", "n", "m", "p"];

export const STATIC_JOB_INPUTS = {
  bonus: {
    id: "bonus_eligible_pct",
    label: "Bonus Eligible %"
  }, 
  flsa: {
    id: "flsa_exempt_pct",
    label: "FLSA Exempt %"
  }, 
  lti: {
    id: "lti_eligible_pct",
    label: "LTI Eligible %"
  },
  jobCode: {
    id: "job_code",
    label: "Survey Job Code"
  },
  jobCurrency: {
    id: "currency",
    label: "Currency"
  }, 
  jobDescription: {
    id: "job_description",
    label: "Survey Job Description"
  },
  jobScope: {
    id: "job_scope",
    label: "Data Cut/Scope Desc"
  },
  jobTitle: {
    id: "job_title",
    label: "Survey Job Title"
  },
  maxRange: {
    id: "avg_max",
    label: "Average Salary Range Maximum"
  },
  midRange: {
    id: "avg_mid",
    label: "Average Salary Range Midpoint"
  },
  minRange: {
    id: "avg_min",
    label: "Average Salary Range Minimum"
  },
  overtime: {
    id: "overtime_eligible_pct",
    label: "Overtime Eligible %"
  },
  surveySource: {
    id: "survey_code",
    label: "Survey Source"
  }
}

export const STATIC_SURVEY_INPUTS = {
  subscribeAll: {
    id: "apply_sub_to_subgroups",
    label: "Subscribe to all groups"
  },
  surveyCode: {
    id: "pub_survey_code",
    label: "Survey Code"
  },
  surveyEffectiveDate: {
    id: "pub_survey_effective_date",
    label: "Survey Effective Date"
  },
  surveyGeography: {
    id: "geography",
    label: "Geography"
  },
  surveyIndustry: {
    id: "industry",
    label: "Industry"
  },
  surveyName: {
    id: "pub_survey_short_name",
    label: "Survey Name"
  },
  surveyOverview: {
    id: "survey_overview",
    label: "Survey Overview"
  },
  surveyPublisher: {
    id: "pub_survey_publisher",
    label: "Survey Publisher"
  }
}

